var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CarouselLarge',{staticClass:"show-xl-carrousel",attrs:{"infoCards":_vm.infoCards,"routesConfigNoteCard":_vm.routesConfigNoteCard,"personalData":_vm.personalData,"emailRoutesConfig":_vm.emailRoutesConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }